import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Tab,
  Tabs,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Rating,
  Divider,
  Button,
  styled,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useNavigate } from 'react-router-dom';

// Sample Doctor Data (Replace with your actual data fetching)
// const doctors = [
//   {
//     id: 1,
//     name: 'Rodrigo Hartman',
//     specialty: 'Dentist',
//     procedure: 'Dental Scaling & Polishing',
//     hospital: 'National Hospital ABUJA',
//     rating: 4.8,
//     reviews: 10,
//     image: 'https://via.placeholder.com/150/abcdef', // Placeholder image
//   },
//   {
//     id: 2,
//     name: 'Ember Wynn',
//     specialty: 'Pediatric Neurologist',
//     procedure: 'Pediatric Neurology',
//     hospital: 'National Hospital ABUJA',
//     rating: 5.0,
//     reviews: 20,
//     image: 'https://via.placeholder.com/150/123456', // Placeholder image
//   },
//   {
//     id: 3,
//     name: 'Romeo Levy',
//     specialty: 'Cardiologist',
//     procedure: 'Pediatric Cardiologist',
//     hospital: 'National Hospital ABUJA',
//     rating: 4.8,
//     reviews: 12,
//     image: 'https://via.placeholder.com/150/fedcba', // Placeholder image
//   },
//   {
//     id: 4,
//     name: 'Luca Craft',
//     specialty: 'Dentist',
//     procedure: 'Dental Scaling & Polishing',
//     hospital: 'National Hospital ABUJA',
//     rating: 5.0,
//     reviews: 15,
//     image: 'https://via.placeholder.com/150/654321', // Placeholder image
//   },
//   {
//     id: 5,
//     name: 'Ryleigh Berger',
//     specialty: 'Pediatric Neurologist',
//     procedure: 'Pediatric Neurologist',
//     hospital: 'National Hospital ABUJA',
//     rating: 4.8,
//     reviews: 10,
//     image: 'https://via.placeholder.com/150/aabbcc', // Placeholder image
//   },
// ];

const StyledDoctorCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

const DoctorListMobile = ({doctors}) => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
    // Implement filtering logic based on the tab
  };

  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 'sm', margin: '0 auto', height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
            Doctors
          </Typography>
          <IconButton color="inherit" aria-label="search">
            <SearchIcon />
          </IconButton>
        </Toolbar>
        <Tabs value={selectedTab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
          <Tab label="All" />
          <Tab label="General" />
          <Tab label="Dentist" />
          <Tab label="Neurologist" />
          {/* Add more tabs based on specialties */}
        </Tabs>
      </AppBar>
      <Box sx={{ p: 2, flexGrow: 1, overflowY: 'auto'}}>
        {doctors?.map((doctor) => (
          <StyledDoctorCard onClick={()=> navigate(`/profile?cat=doctor&id=${doctor?.id}`)} key={doctor.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2 ,  "&:hover": { cursor: "pointer", backgroundColor:"#f9fdf9" }  }}>
              <Avatar src={doctor.profilePicture} alt={doctor?.firstName} sx={{ width: 80, height: 80, mr: 2 }} />
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold">{`${doctor?.firstName} ${doctor?.lastName}`}</Typography>
                <Typography variant="caption" color="text.secondary">{doctor?.department}</Typography>
                <Typography variant="caption" color="text.secondary">{doctor.userRoles[0]?.roleSpecialist?.role?.name || ''} | {doctor?.healthCareProvider?.name}</Typography>
                <Rating name={`rating-${doctor.id}`} value={doctor?.rating} readOnly size="small" />
                <Typography variant="caption" color="text.secondary">({doctor?.reviews} reviews)</Typography>
              </Box>
              <IconButton aria-label="add to favorites" size="small">
                <FavoriteBorderIcon />
              </IconButton>
            </Box>
            {doctors.indexOf(doctor) < doctors.length - 1 && <Divider />}
          </StyledDoctorCard>
        ))}
      </Box>
    </Box>
  );
};

export default DoctorListMobile;